/**
 * Vuex store module for Zoom video conferencing integration.
 *
 * @module store/modules/zoom
 * @description Manages state for Zoom meeting creation and tracking within chat sessions.
 * Stores meeting details including user IDs, start URLs, and join URLs for video calls.
 *
 * @example
 * // Access state
 * this.$store.state.zoom.meetings
 *
 * // Dispatch action
 * this.$store.dispatch('ZOOM_MEETING_START', { chat, meeting_id })
 */
import actions from "./actions";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { ZoomState } from "./types";
import { RootState } from "@/store/types";

const zoom: Module<ZoomState, RootState> = {
  // namespaced: true,
  actions,
  mutations,
  state,
};

export default zoom;
